import React, { Component } from "react";
import "./stylesheets/mywork.css";
import Header from "../../components/header/Header";
import { getJobs, getJobsAllowanceMyWork } from "../../modules/serverCall";
import "react-datepicker/dist/react-datepicker.css";
import { Offline, Online } from "react-detect-offline";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import AllowanceBox from "../../components/backoffice/AllowanceBox";

export default class MyWork extends Component {
  constructor(props) {
    super(props);
    let params = new URLSearchParams(window.location.pathname);
    var monthSaveData = params.get("month");
    var jobDataMain = JSON.parse(localStorage.getItem("jobCountData"));
    if (
      jobDataMain !== "" &&
      jobDataMain !== null &&
      jobDataMain !== undefined
    ) {
      if (
        monthSaveData !== "" &&
        monthSaveData !== null &&
        monthSaveData !== undefined
      ) {
        jobDataMain = "";
      } else {
        jobDataMain = JSON.parse(localStorage.getItem("jobCountData"));
      }
    }
    this.state = {
      currnetmonthdata: "",
      loading: false,
      currnetmonth: "",
      currnetyear: "",
      customerid: "",
      jobDataMain: jobDataMain,
      jobAllowancedata: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    var month = "";
    var currentCount = "";
    var monthData = "";
    var year = "";

    const accesstokendata = localStorage.getItem("access_token");
    const siteID = localStorage.getItem("siteID");
    const readData = JSON.parse(accesstokendata);
    const cusId = readData.userdata.user_id;
    let params = new URLSearchParams(window.location.pathname);
    var monthSaveData = params.get("month");

    if (
      monthSaveData !== "" &&
      monthSaveData !== null &&
      monthSaveData !== undefined
    ) {
      monthData = params.get("month");
      year = params.get("year");
      var newDate = params.get("jobdate");
      var sendData = {
        month: monthData,
        year: year,
        techId: cusId,
      };
      var sendAllowanceData = {
        month: monthData,
        year: year,
        techId: cusId,
        siteID: siteID,
      };
      this.setState({
        currnetyear: year,
        currnetmonthdata: new Date(newDate),
        currnetmonth: monthData,
      });
      const fetchjobs = async () => {
        this.setState({
          loading: true,
        });
        const responsejobs = await getJobs(sendData);
        const datarespjobs = await responsejobs;
        if (datarespjobs) {
          this.setState({
            loading: false,
          });
        } else {
          this.setState({
            loading: false,
          });
        }
        this.setState({
          jobDataMain: datarespjobs,
        });
      };

      const fetchjobsAllowance = async () => {
        const responsejobs = await getJobsAllowanceMyWork(sendAllowanceData);
        const datarespjobs = await responsejobs;

        this.setState({
          jobAllowancedata: datarespjobs,
        });
      };
      fetchjobs();
      fetchjobsAllowance();
    } else {
      month = new Date().getMonth();
      currentCount = parseInt(month);
      monthData = currentCount + 1;
      year = new Date().getFullYear();

      var sendData = {
        month: monthData,
        year: year,
        techId: cusId,
      };
      var sendAllowanceData = {
        month: monthData,
        year: year,
        techId: cusId,
        siteID: siteID,
      };
      const fetchjobs = async () => {
        const responsejobs = await getJobs(sendData);
        const datarespjobs = await responsejobs;
        this.setState({
          jobDataMain: datarespjobs,
        });
      };

      const fetchjobsAllowance = async () => {
        const responsejobs = await getJobsAllowanceMyWork(sendAllowanceData);
        const datarespjobs = await responsejobs;

        this.setState({
          jobAllowancedata: datarespjobs,
        });
      };
      fetchjobs();
      fetchjobsAllowance();

      this.setState({
        currnetmonthdata: new Date(),
        currnetyear: year,
        customerid: cusId,
        currnetmonth: monthData,
      });
    }
  }

  handleChange = (event) => {
    var month = new Date().getMonth();
    var currentCount = parseInt(month);
    var monthData = currentCount + 1;
    var year = new Date().getFullYear();
    const accesstokendata = localStorage.getItem("access_token");
    const siteID = localStorage.getItem("siteID");
    const readData = JSON.parse(accesstokendata);
    const cusId = readData.userdata.user_id;
    var sendData = {
      month: monthData,
      year: year,
      techId: cusId,
    };
    var sendAllowanceData = {
      month: monthData + 1,
      year: year,
      techId: cusId,
      siteID: siteID,
    };

    this.setState({
      currnetyear: year,
      customerid: cusId,
      currnetmonth: monthData,
    });
    const fetchjobs = async () => {
      const responsejobs = await getJobs(sendData);
      const datarespjobs = await responsejobs;
      this.setState({
        jobDataMain: datarespjobs,
      });
    };
    const fetchjobsAllowance = async () => {
      const responsejobs = await getJobsAllowanceMyWork(sendAllowanceData);
      const datarespjobs = await responsejobs;
      this.setState({
        jobAllowancedata: datarespjobs,
      });
    };
    fetchjobs();
    fetchjobsAllowance();
  };

  handleInputChange = (event) => {
    this.setState({ currnetmonthdata: event });
    var monthData = event.getMonth();
    var year = event.getFullYear();
    const accesstokendata = localStorage.getItem("access_token");
    const siteID = localStorage.getItem("siteID");
    const readData = JSON.parse(accesstokendata);
    const cusId = readData.userdata.user_id;
    var sendData = {
      month: monthData + 1,
      year: year,
      techId: cusId,
    };

    var sendAllowanceData = {
      month: monthData + 1,
      year: year,
      techId: cusId,
      siteID: siteID,
    };

    this.setState({
      currnetyear: year,
      customerid: cusId,
      currnetmonth: monthData + 1,
    });
    const fetchjobs = async () => {
      const responsejobs = await getJobs(sendData);
      const datarespjobs = await responsejobs;
      this.setState({
        jobDataMain: datarespjobs,
      });
    };
    const fetchjobsAllowance = async () => {
      const responsejobs = await getJobsAllowanceMyWork(sendAllowanceData);
      const datarespjobs = await responsejobs;
      this.setState({
        jobAllowancedata: datarespjobs,
      });
    };
    fetchjobs();
    fetchjobsAllowance();
  };

  render() {
    const loadingImg = require("../../assets/images/Hourglass.gif");
    const selectedTenant = localStorage.getItem("selected_tenant");
    const selectedTenantData = JSON.parse(selectedTenant);

    var searchDropMain = JSON.parse(localStorage.getItem("searchDrop"));
    var unsyData = localStorage.getItem("unsyu");
    var currnetMonth = "";
    var currnetMonthData = this.state.currnetmonthdata;
    var onLineStatus = navigator.onLine;
    if (currnetMonthData === "") {
      currnetMonth = new Date();
    } else {
      currnetMonth = currnetMonthData;
    }
    if (unsyData !== "" && unsyData !== null && unsyData !== undefined) {
      unsyData = parseInt(localStorage.getItem("unsyu"));
    }
    if (
      searchDropMain !== "" &&
      searchDropMain !== null &&
      searchDropMain !== undefined
    ) {
      searchDropMain = JSON.parse(localStorage.getItem("searchDrop"));
    }

    return (
      <div>
        <Header />
        <div className="topconw">
          <div className="row row-mywork">
            <div className="col-md-12 alignDataCenter">
              <div className="d-flex flex-row justify-content-between align-items-center filters">
                <h2>
                  <b className="MyWork">My Works</b>
                </h2>
                <div className="right-sort alignData">
                  <div className="sort-by">
                    <DatePicker
                      selected={currnetMonth}
                      onChange={(date) => this.handleInputChange(date)}
                      dateFormat="MMM yyyy"
                      showMonthYearPicker
                      className="input-date-data"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {onLineStatus === true ? (
            ""
          ) : (
            <div className="col-md-4 cardMainDataSy cardMainDataSyMyWork">
              <div className="p-card rounded px-3">
                <p className="mt-2 mtOffline">Unsynchronized</p>
                <span className="d-block blockOffline mb-5">
                  {unsyData !== "" &&
                  unsyData !== null &&
                  unsyData !== undefined
                    ? unsyData
                    : 0}
                </span>
              </div>
            </div>
          )}
          {onLineStatus === true ? (
            <div className="row mt-1 boxAlign boxAlignMyWork paddClass">
              {this.state.jobDataMain !== "" && this.state.jobDataMain !== null
                ? this.state.jobDataMain.map((jobdata, index) => (
                    <>
                      {" "}
                      <Link
                        className="cardMain"
                        to={
                          "/work-detail/&month=" +
                          this.state.currnetmonth +
                          "&year=" +
                          this.state.currnetyear +
                          "&jobid=" +
                          jobdata.JobTypeID +
                          "&jobtype=" +
                          jobdata.JobType +
                          "&jobdate=" +
                          currnetMonth
                        }
                        key={index + 1}
                      >
                        <div key={index}>
                          <div className="p-card rounded ">
                            <p key={index + 2} className="mt-2">
                              {jobdata.JobType}
                            </p>
                            <span key={index + 3} className="d-block m-auto">
                              {jobdata.JobCount}
                              <br />
                              {selectedTenantData.Tenant !== "Thisco" && (
                                <span> &#x20B9;{jobdata.IncentiveAmount}</span>
                              )}
                            </span>
                          </div>
                        </div>
                      </Link>
                    </>
                  ))
                : ""}
              {this.state.jobAllowancedata.length > 0 &&
                this.state.jobAllowancedata !== null &&
                selectedTenantData.Tenant !== "Thisco" && (
                  <AllowanceBox
                    jobAllowancedata={this.state.jobAllowancedata}
                    jobDataMain={this.state.jobDataMain}
                  />
                )}
            </div>
          ) : (
            <div className="row mt-1 boxAlign boxAlignMyWork paddClass">
              {this.state.jobDataMain !== "" && this.state.jobDataMain !== null
                ? this.state.jobDataMain.map((jobdata, index) => (
                    <div
                      className="col-md-4 cardMainData cardMainDataMyWork"
                      key={index}
                    >
                      <div className="p-card rounded px-3">
                        <p className="mt-2">{jobdata.JobType}</p>
                        <span className="d-block mb-5">
                          {jobdata.JobCount}
                          <br />
                          &#x20B9;{jobdata.IncentiveAmount}
                        </span>
                      </div>
                    </div>
                  ))
                : ""}
            </div>
          )}

          {/* <div className="row mt-1 boxAlign boxAlignMyWork">

          <Online>
            {this.state.jobDataMain!== '' && this.state.jobDataMain !== null ?
                              this.state.jobDataMain.map((jobdata,index) => (
                  <Link className="cardMain" to={'/work-detail/&month='+this.state.currnetmonth+'&year='+this.state.currnetyear+'&jobid='+jobdata.JobTypeID+'&jobtype='+jobdata.JobType+'&jobdate='+currnetMonth} key={index +1 }><div className="col-md-4" key={index}>
                      <div className="p-card rounded px-3" >
                        <p key={index +2 } className="mt-2">{jobdata.JobType}</p>
                        <span key={index +3 } className="d-block mb-5">{jobdata.JobCount+" (Rs "+jobdata.IncentiveAmount+" )"}</span>
                    </div>
                  </div></Link>
               )):""
             }
            </Online>
            <Offline>
              {this.state.jobDataMain!== '' && this.state.jobDataMain !== null ?
                                this.state.jobDataMain.map((jobdata,index) => (
                    <div className="col-md-4 cardMainData cardMainDataMyWork" key={index}>
                        <div className="p-card rounded px-3">
                          <p className="mt-2">{jobdata.JobType}</p>
                          <span className="d-block mb-5">{jobdata.JobCount}</span>
                      </div>
                    </div>
                 )):""
               }
            </Offline>
          </div> */}
        </div>
        {this.state.loading === true ? (
          <span className="preloader">
            <img src={loadingImg} className="loaderImg" />
          </span>
        ) : (
          ""
        )}
      </div>
    );
  }
}
